import { Dropdown, Grid, Input } from "antd";
import { CenterPopup, Stepper } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Users from "../../assets/images/icons/Users";
import { P1, P3 } from "../NormalFonts";
import { CountDropdownProps } from "./data";
import styles from "./styles.module.scss";
import "./styles.scss";

const CountDropdown: React.FC<CountDropdownProps> = ({
  form,
  params = { adults: 0, kids: 0 },
  studentLimit,
  setParams,
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const [showCountDropdown, setShowCountDropdown] = useState<boolean>(false);
  const [showMobilePopup, setShowMobilePopup] = useState<boolean>(false);
  const [adultCounts, setAdultCounts] = useState<number>(0);
  const [kidsCounts, setKidsCounts] = useState<number>(0);

  const MAX_MEMBER = studentLimit || 6;

  const onAdultChange = (val: number) => {
    setAdultCounts(val);
    onAdultCountChange(val);
  };

  const onKidsChange = (val: number) => {
    setKidsCounts(val);
    onKidsCountChange(val);
  };

  const handleOpenChange = (flag: boolean) => {
    setShowCountDropdown(flag);
  };

  const renderDropdownContent = () => {
    return (
      <div className={`${styles.countDropdownWrapper} `}>
        <div className={styles.wrapper}>
          <P1 color="var(--Neutral-dark-70)">
            {t("home.stepper.adults.title")}
          </P1>
          <Stepper
            className="custom-stepper"
            value={adultCounts}
            max={MAX_MEMBER - kidsCounts}
            min={0}
            onChange={onAdultChange}
          />
        </div>
        <div className={styles.wrapper}>
          <P1 color="var(--Neutral-dark-70)">{t("home.stepper.kids.title")}</P1>
          <Stepper
            className="custom-stepper"
            value={kidsCounts}
            max={MAX_MEMBER - adultCounts}
            min={0}
            onChange={onKidsChange}
          />
        </div>
        <P3
          color="var(--info)"
          dangerouslySetInnerHTML={{ __html: t("age.recomendation") }}
        />
      </div>
    );
  };

  const togglePopup = () => {
    setShowMobilePopup(true);
  };

  const onAdultCountChange = (val: number) => {
    const kids = form.getFieldValue("kids");
    const count = Number(val) === 0 && (kids === 0 || !kids) ? undefined : true;
    form.setFieldsValue({ adults: Number(val), count });
    // 触发 count 字段的重新验证
    form.validateFields(["count"]);
    setParams?.({ ...params, adults: Number(val) });
  };
  const onKidsCountChange = (val: number) => {
    const adults = form.getFieldValue("adults");
    const count =
      Number(val) === 0 && (adults === 0 || !adults) ? undefined : true;
    form.setFieldsValue({ kids: Number(val), count });
    // 触发 count 字段的重新验证
    form.validateFields(["count"]);
    setParams?.({ ...params, kids: Number(val) });
  };

  useEffect(() => {
    setAdultCounts(params.adults);
    setKidsCounts(params.kids);
  }, []);

  return (
    <>
      {screens.sm ? (
        <Dropdown
          open={showCountDropdown}
          dropdownRender={(originNode) => renderDropdownContent()}
          trigger={["click"]}
          onOpenChange={handleOpenChange}
        >
          <Input
            readOnly
            value={
              adultCounts <= 0 && kidsCounts <= 0
                ? undefined
                : `${t(`home.search.adults`, { count: adultCounts })} ${t(
                    `home.search.kids`,
                    { count: kidsCounts }
                  )}`
            }
            placeholder={t("home.searchbar.count.hint")}
            addonBefore={
              screens.lg ? null : (
                <Users
                  style={{
                    fontSize: 24,
                    color: "var(--Neutral-dark-80)",
                  }}
                />
              )
            }
            addonAfter={
              screens.lg ? (
                <Users
                  style={{
                    fontSize: 24,
                    color: "var(--Neutral-dark-80)",
                  }}
                />
              ) : null
            }
          />
        </Dropdown>
      ) : (
        <Input
          readOnly
          onClick={togglePopup}
          value={
            adultCounts <= 0 && kidsCounts <= 0
              ? undefined
              : `${t(`home.search.adults`, { count: adultCounts })} ${t(
                  `home.search.kids`,
                  { count: kidsCounts }
                )}`
          }
          styles={{
            input: {
              padding: "4px",
            },
          }}
          placeholder={t("home.searchbar.count.hint")}
          addonBefore={
            screens.lg ? null : (
              <Users
                style={{
                  fontSize: 24,
                  color: "var(--Neutral-dark-80)",
                }}
              />
            )
          }
          addonAfter={
            screens.lg ? (
              <Users
                style={{
                  fontSize: 24,
                  color: "var(--Neutral-dark-80)",
                }}
              />
            ) : null
          }
        />
      )}
      <CenterPopup
        getContainer={() =>
          document.getElementById("containerElement") || document.body
        }
        onClose={() => setShowMobilePopup(false)}
        closeOnMaskClick={true}
        visible={showMobilePopup}
        style={{ zIndex: 10000 }}
      >
        {renderDropdownContent()}
      </CenterPopup>
    </>
  );
};

export default CountDropdown;
